export enum TipoSupportoDocumentoEnum {
    CARTACEO = <any>"CARTACEO",
    DIGITALE = <any>"DIGITALE"
}
